import getEnabledQuestions from '@opsbase/lib-form/helpers/getEnabledQuestions';
import Pane from '@opsbase/web-layout/Pane';
import chunk from 'lodash/chunk';
import React, { useContext, useMemo } from 'react';
import useReportCSS from '../../useReportCSS';
import DetailsOpReportAnswerTable from './DetailsOpReportAnswerTable';
import DetailsOpReportContext from './DetailsOpReportContext';
export function DetailsOpReportResponses() {
    const { form, def, issues, notes } = useContext(DetailsOpReportContext);
    const pdf = !!def.pdf;
    const myCss = useReportCSS(pdf);
    return useMemo(() => {
        const enabledQuestions = getEnabledQuestions(form.questionTree);
        const unrestrictedQuestionIds = getEnabledQuestions(form.questionTree, z => { var _a; return !((_a = form.answers[z.nodeId]) === null || _a === void 0 ? void 0 : _a.notApplicable); }).map(z => z.nodeId);
        const questionsPerPage = chunk(enabledQuestions, pdf ? 7 : 100000);
        return (React.createElement(React.Fragment, null, questionsPerPage.map((questions, pageIdx) => (React.createElement("div", { key: 'page' + pageIdx, className: myCss.page2 },
            React.createElement(Pane, null,
                React.createElement("div", { className: myCss.heading1 }, pageIdx > 0 ? 'Responses (continued)' : 'Responses'),
                React.createElement(DetailsOpReportAnswerTable, { questions: questions, hasIssues: !!(issues === null || issues === void 0 ? void 0 : issues.length), hasNotes: !!(notes === null || notes === void 0 ? void 0 : notes.length), unrestrictedQuestionIds: unrestrictedQuestionIds })))))));
    }, [issues, notes, form, pdf, myCss.page2, myCss.heading1]);
}
export default DetailsOpReportResponses;
